<template>
  <div class="w210 bgwhite">
    <div class="t_listmenu f18"><i class="iconfont icon-p-types"></i>物流分类</div>
    <div class="t_menuicon">
      <ul>
        <li :class="companyid=='1'?'t_hov':''">
          <router-link :to="{name:'logisticsdirectories',query:{companyid:'1',menutitle:'公路物流'}}">
            <span>
              <i class="gonglu"></i>
            </span>
            公路物流
          </router-link>
        </li>
        <li :class="companyid=='11'?'t_hov':''">
          <router-link :to="{name:'logisticsdirectories',query:{companyid:'11',menutitle:'铁路物流'}}">
            <span>
              <i class="dashuju"></i>
            </span>
            铁路物流
          </router-link>
        </li>
       <li :class="companyid=='12'?'t_hov':''">
          <router-link :to="{name:'logisticsdirectories',query:{companyid:'12',menutitle:'空运物流'}}">
            <span>
              <i class="kongyunchukou"></i>
            </span>
            空运物流
          </router-link>
        </li>
        <li :class="companyid=='0'?'t_hov':''">
          <router-link :to="{name:'logisticsdirectories',query:{companyidfirst:'2',companyid:'0',menutitle:'仓配企业'}}">
            <span>
              <i class="cp"></i>
            </span>
            仓配企业
          </router-link>
        </li>
        <li :class="companyid=='19'?'t_hov':''">
          <router-link :to="{name:'logisticsdirectories',query:{companyid:'19',menutitle:'物流园区'}}">
            <span>
              <i class="yq"></i>
            </span>
            物流园区
          </router-link>
        </li>
       <li :class="companyid=='8'?'t_hov':''">
          <router-link :to="{name:'logisticsdirectories',query:{companyid:'8',menutitle:'冷链物流'}}">
            <span>
              <i class="ll"></i>
            </span>
            冷链物流
          </router-link>
        </li>
        <li :class="companyid=='7'?'t_hov':''">
          <router-link :to="{name:'logisticsdirectories',query:{companyid:'7',menutitle:'医药物流'}}">
            <span>
              <i class="yy"></i>
            </span>
            医药物流
          </router-link>
        </li>
        <li :class="companyid=='6'?'t_hov':''">
          <router-link :to="{name:'logisticsdirectories',query:{companyid:'6',menutitle:'大件物流'}}">
            <span>
              <i class="dj"></i>
            </span>
            大件物流
          </router-link>
        </li>
        <li :class="companyid=='9'?'t_hov':''">
          <router-link :to="{name:'logisticsdirectories',query:{companyid:'9',menutitle:'危险品物流'}}">
            <span>
              <i class="wx"></i>
            </span>
            危险品物流
          </router-link>
        </li>
       <li :class="companyid=='53'?'t_hov':''">
          <router-link :to="{name:'logisticsdirectories',query:{companyid:'53',menutitle:'应急物流'}}">
            <span>
              <i class="yj"></i>
            </span>
            应急物流
          </router-link>
        </li>
        <li :class="companyid=='22'?'t_hov':''">
          <router-link :to="{name:'logisticsdirectories',query:{companyid:'22',menutitle:'货车销售'}}">
            <span>
              <i class="xs"></i>
            </span>
            货车销售
          </router-link>
        </li>
        <li :class="companyid=='24'?'t_hov':''">
          <router-link :to="{name:'logisticsdirectories',query:{companyid:'24',menutitle:'车后市场'}}">
            <span>
              <i class="hc"></i>
            </span>
            车后市场
          </router-link>
        </li>
        <li :class="companyid=='21'?'t_hov':''">
          <router-link :to="{name:'logisticsdirectories',query:{companyid:'21',menutitle:'物流装备'}}">
            <span>
              <i class="zb"></i>
            </span>
            物流装备
          </router-link>
        </li>
         <li :class="companyid=='23'?'t_hov':''">
          <router-link :to="{name:'logisticsdirectories',query:{companyid:'23',menutitle:'物流金融'}}">
            <span>
             <i class="jr"></i>
            </span>
            物流金融
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name:'menulist',
  props:["companyid"],
  data(){
    return{
      
    }
  }
}
</script>
<style scoped>
.t_listmenu{
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #f8fbff;
}
.t_menuicon{
  overflow: hidden;
  padding: 13px 0 15px;
}
.t_menuicon li{
  width: 50%;
  float: left;
  text-align: center;
  line-height: 37px;
}
.t_menuicon li a{
  color: #333;
}
.t_menuicon li a:hover,.t_menuicon li.t_hov a{
  color: #0060c6;
}
.t_menuicon li a:hover span,.t_menuicon li.t_hov a span{
  border:1px solid #0060c6;
}
.t_menuicon li span{
  width:42px ;
  height: 42px;
  background: #f2f9fc;
  border-radius: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px auto 5px;
  border:1px solid #f2f9fc;
}
</style>


// WEBPACK FOOTER //
// src/components/Public/menuList.vue